import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import TabPage from "./../../factories/tab-page";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import ChildTabViewModel from "./../../factories/child-tab-view-model";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
function ConfigurationItemAdditionalDataPersonViewModel(tabPage, parent) {
    var self = this;
    ChildTabViewModel.call(self, tabPage);
    self.Bao = Bao;
    self.ConfigurationItem = parent;
    self.Refresh = function () { };
    self.CompleteCheck = function () {
        return true;
    };
    self.loaded = function () {
        return self.Refresh();
    };
}
;
Bao.inherit(ConfigurationItemAdditionalDataPersonViewModel, ChildTabViewModel);
export default ConfigurationItemAdditionalDataPersonViewModel;